/**
 * DocumentTitle: sets the browser tab title for the page that renders it.
 *
 * `index.html` ships a static `<title>`, and a browser uses the first `<title>` in
 * the document, so a React-rendered `<title>` element would never win. This
 * component writes `document.title` instead (an effect that syncs with the browser,
 * not data loading) and restores the product name when the page unmounts.
 *
 *   <DocumentTitle title="Queue" />   →   "Queue · Norican I2Q"
 */

import { useEffect } from "react";

import { PRODUCT_NAME as PRODUCT } from "@/lib/product";

export interface DocumentTitleProps {
  /** The page name; the product name is appended. */
  title: string;
}

export function DocumentTitle({ title }: DocumentTitleProps) {
  useEffect(() => {
    const trimmed = title.trim();
    document.title = trimmed ? `${trimmed} · ${PRODUCT}` : PRODUCT;
    return () => {
      document.title = PRODUCT;
    };
  }, [title]);
  return null;
}
